import axios from 'axios';

export const waitlistSignup = (data, onFinish) => {
  axios
    .post(`${process.env.GATSBY_WWW_BACKEND_URL}/subscribe`, data, {
      headers: { 'content-type': 'application/json' },
    })
    .then((res) => {
      if (res.status === 200) {
        onFinish(true);
        if (window.fbq) {
          window.fbq('track', 'Lead');
        }
      }
    })
    .catch(() => {
      onFinish(false);
    });
};

export const waitlistSignupFromBlog = (data, onFinish) => {
  axios
    .post(`${process.env.GATSBY_WWW_BACKEND_URL}/subscribeFromBlog`, data, {
      headers: { 'content-type': 'application/json' },
    })
    .then((res) => {
      if (res.status === 200) {
        onFinish(true);
        window.fbq('track', 'Lead');
      }
    })
    .catch(() => {
      onFinish(false);
    });
};

export const spSignUpListA = (data, onFinish) => {
  axios
    .post(
      `${process.env.GATSBY_WWW_BACKEND_URL}/successPredictorListAsignup`,
      data,
      {
        headers: { 'content-type': 'application/json' },
      },
    )
    .then((res) => {
      if (res.status === 200) {
        onFinish(true);
      }
    })
    .catch(() => {
      onFinish(false);
    });
};

export const spSignUpListB = (data, onFinish) => {
  axios
    .post(
      `${process.env.GATSBY_WWW_BACKEND_URL}/successPredictorListBsignup`,
      data,
      {
        headers: { 'content-type': 'application/json' },
      },
    )
    .then((res) => {
      if (res.status === 200) {
        console.log(res);
        onFinish(true);
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      onFinish(false);
    });
};

export const webinarMarch2024 = (data, onFinish) => {
  axios
    .post(`${process.env.GATSBY_WWW_BACKEND_URL}/b2bWebinarMarch2024`, data, {
      headers: { 'content-type': 'application/json' },
    })
    .then((res) => {
      if (res.status === 200) {
        console.log(res);
        onFinish?.(true);
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      onFinish?.(false);
    });
};

export const spBetaAccess = (data, onFinish) => {
  axios
    .post(`${process.env.GATSBY_WWW_BACKEND_URL}/spBetaAccess`, data, {
      headers: { 'content-type': 'application/json' },
    })
    .then((res) => {
      if (res.status === 200) {
        console.log(res);
        onFinish?.(true);
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      onFinish?.(false);
    });
};

export const aiChecklist = (data, onFinish) => {
  axios
    .post(`${process.env.GATSBY_WWW_BACKEND_URL}/aiChecklist`, data, {
      headers: { 'content-type': 'application/json' },
    })
    .then((res) => {
      if (res.status === 200) {
        console.log(res);
        onFinish?.(true);
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      onFinish?.(false);
    });
};

export const clinicalEmailSignUp = (data, onFinish) => {
  axios
    .post(`${process.env.GATSBY_WWW_BACKEND_URL}/clinicalEmailSignUp`, data, {
      headers: { 'content-type': 'application/json' },
    })
    .then((res) => {
      if (res.status === 200) {
        console.log(res);
        onFinish?.(true);
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      onFinish?.(false);
    });
};

export const spLiveDemo = (data, onFinish) => {
  axios
    .post(
      `${process.env.GATSBY_WWW_BACKEND_URL}/subscribe/klayvio/VLZshF`,
      data,
      {
        headers: { 'content-type': 'application/json' },
      },
    )
    .then((res) => {
      if (res.status === 200) {
        onFinish?.(true);
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      onFinish?.(false);
    });
};

export const embryoAssistLiveDemo = (data, onFinish) => {
  axios
    .post(
      `${process.env.GATSBY_WWW_BACKEND_URL}/subscribe/klayvio/WgbpL7`,
      data,
      {
        headers: { 'content-type': 'application/json' },
      },
    )
    .then((res) => {
      if (res.status === 200) {
        onFinish?.(true);
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      onFinish?.(false);
    });
};

export const stimAssistAMA = (data, onFinish) => {
  axios
    .post(
      `${process.env.GATSBY_WWW_BACKEND_URL}/subscribe/klayvio/U5uGY2`,
      data,
      {
        headers: { 'content-type': 'application/json' },
      },
    )
    .then((res) => {
      if (res.status === 200) {
        onFinish?.(true);
        return;
      }
    })
    .catch((err) => {
      console.log(err);
      onFinish?.(false);
    });
};
